import { fg } from '@atlassian/jira-feature-gating';

export default {
	get(): boolean {
		return fg('thor_colourful_single_select_milestone2_gate');
	},
};
